import type { RouteEntry } from '@/routeRegistry';

export type KnownRole =
  | 'admin'
  | 'superadmin'
  | 'nominee'
  | 'teacher'
  | 'guardian'
  | 'athlete'
  | 'prospect'
  | 'coach'
  | 'sponsor';

export function roleToPath(role?: string | null) {
  const routes: RouteEntry[] = (typeof window !== 'undefined' && Array.isArray(window.__ROUTES__) && window.__ROUTES__) || [];
  const hasRoute = (path: string) => routes.some(r => r.path === path);

  switch (role) {
    case 'admin':
    case 'superadmin':
      if (hasRoute('/portal/admin')) return '/portal/admin'
      if (hasRoute('/admin')) return '/admin'
      return '/portal/admin'
    case 'nominee':
      // Unified pool role — all confirmed nominees until draw win
      return '/portal/nominee'
    case 'teacher':
      // Upgraded from nominee after winning the draw
      if (hasRoute('/portal/teacher')) return '/portal/teacher'
      return '/portal/teacher'
    case 'guardian':
      if (hasRoute('/portal/parent')) return '/portal/parent'
      if (hasRoute('/portal/prospect')) return '/portal/prospect'
      return '/portal/parent'
    case 'athlete':
    case 'prospect':
      // Prospects in an active locker room
      return '/portal/locker'
    case 'coach':
      // Upgraded from nominee after winning the draw
      return '/portal/locker'
    case 'sponsor':
      if (hasRoute('/portal/sponsor')) return '/portal/sponsor'
      return hasRoute('/sponsor/dashboard') ? '/sponsor/dashboard' : '/sponsor/dashboard'
    default:
      return '/welcome'
  }
}

export {};
